import { configureStore } from "@reduxjs/toolkit";
import groupsReducer from "./reducers/groupsReducer";
import actionsReducer from "./reducers/actionModulesReducer";
import reportingReducer from "./reducers/reportingReducer";
import certificatesReducer from "./reducers/certificatesReducer";
import tableManagementReducer from "./reducers/tableManagementReducer";
import notificationReducer from "./reducers/notificationReducer";
import configurationReducer from "./reducers/configurationReducer";
import loginMetadataReducer from "./reducers/loginMetadataReducer";
import firstOpenCheckReducer from "./reducers/firstOpenCheckReducer";
import serviceModulesReducer from "./reducers/serviceModulesReducer";
import walletReducer from "./reducers/walletReducer";
import employeesReducer from "./reducers/employeesReducer";
import profileReducer from "./reducers/profileReducer";
import translationsReducer from "./reducers/translationsReducer";
import permissionsReducer from "./reducers/permissionsReducer";
import companyManagementReducer from "./reducers/companyManagementReducer";
import shopModulesReducer from "./reducers/shopModulesReducer";
import subCompaniesReducer from "./reducers/subCompaniesReducer";
import requestStateReducer from "./reducers/requestStateSlice";
import walletTypesReducer from "./reducers/walletTypesReducer";
import statusServiceModuleReducer from "./reducers/statusServiceModuleReducer";

export const store = configureStore({
  reducer: {
    groups: groupsReducer,
    actions: actionsReducer,
    employees: employeesReducer,
    reporting: reportingReducer,
    certificates: certificatesReducer,
    tableManagement: tableManagementReducer,
    notifications: notificationReducer,
    configuration: configurationReducer,
    firstOpenCheck: firstOpenCheckReducer,
    loginMetadata: loginMetadataReducer,
    serviceModules: serviceModulesReducer,
    wallet: walletReducer,
    profile: profileReducer,
    translations: translationsReducer,
    permissions: permissionsReducer,
    companyManagement: companyManagementReducer,
    shopModules: shopModulesReducer,
    subCompanies: subCompaniesReducer,
    requestState: requestStateReducer,
    walletTypes: walletTypesReducer,
    statusServiceModule: statusServiceModuleReducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
